import api from '@/resources/system/api/menu.api'
import menu from './data/menu'

export default (mock, result) => {

  mock.onGet(api.getMenu).reply(req => {
    let res = {
      code: 0,
      msg: "请求成功",
      data: {
        menuList: menu
      },
    };

    return new Promise((resolve, reject) => {
      resolve([200, res])
    })
  });
}


